var isCallable = require('../internals/is-callable');
var tryToString = require('../internals/try-to-string');

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a function');
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/a-callable.js
// module id = 134
// module chunks = 1